import axios from 'axios';
import {
  MempoolAddressTransactionDto,
  mempoolAddressTransactionFromApiResponse,
} from '../models/MempoolAddressTransactionDto';

const MEMPOOL_API_BASE_URL = 'https://mempool.space/api';

export class MempoolRepository {
  async getMempoolAddressTransactions(
    address: string,
  ): Promise<MempoolAddressTransactionDto[]> {
    const response = await axios.get(
      `${MEMPOOL_API_BASE_URL}/address/${encodeURIComponent(address)}/txs/mempool`,
    );
    return response.data.map(mempoolAddressTransactionFromApiResponse);
  }
}

export const mempoolRepository = new MempoolRepository();
